import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/leave_request_type_balances',
    name: 'LeaveRequestTypeBalance',
    component: {
      name: 'AdminLeaveRequestTypeBalance',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'user',
      customName: 'views.leave_request_type_balance.index.title',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminLeaveRequestTypeBalanceIndex',
        component: () => import('../views/UserLeaveRequestTypeBalancesIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: ':userId(\\d+)',
        name: 'AdminLeaveRequestTypeBalanceShow',
        component: () => import('../views/UserLeaveRequestTypeBalanceShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminLeaveRequestTypeBalanceIndex',
          },
          customName: 'views.leave_request_type_balance.show.title',
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminLeaveRequestTypeBalanceDetails',
            component: () => import('../views/UserLeaveRequestTypeBalanceDetails.vue'),
            meta: {
              backRoute: { name: 'AdminLeaveRequestTypeBalanceIndex' },
            },
          },
          {
            path: 'new',
            name: 'AdminLeaveRequestTypeBalanceNew',
            component: () => import('../views/UserLeaveRequestTypeBalanceInput.vue'),
            meta: {
              action: 'new',
              resource: 'leave_request_type_balance',
              backRoute: { name: 'AdminLeaveRequestTypeBalanceIndex' },
            },
          },

          /* LEAVE REQUEST TYPE MUTATION TAB */
          {
            path: 'leave_request_type_balance_mutations',
            name: 'LeaveRequestTypeBalanceMutation',
            component: {
              name: 'AdminLeaveRequestTypeBalanceMutation',
              render(h) {
                return h('router-view');
              },
            },
            get redirect() {
              return this.children[0];
            },
            meta: {
              backRoute: { name: 'AdminLeaveRequestTypeBalanceDetails' },
              resource: 'leave_request_type_balance_mutation',
            },
            children: [
              {
                path: '',
                name: 'AdminLeaveRequestTypeBalanceMutations',
                component: () => import('../views/leaveRequestTypeBalanceMutations/LeaveRequestTypeBalanceMutationsIndex.vue'),
                meta: {
                  backRoute: { name: 'AdminLeaveRequestTypeBalanceIndex' },
                },
              },
              {
                path: 'new',
                name: 'AdminLeaveRequestTypeBalanceMutationNew',
                component: () => import('../views/leaveRequestTypeBalanceMutations/LeaveRequestTypeBalanceMutationInput.vue'),
                meta: {
                  action: 'new',
                  backRoute: { name: 'AdminLeaveRequestTypeBalanceMutations' },
                },
              },
              {
                path: ':leaveRequestTypeBalanceMutationId(\\d+)',
                name: 'AdminLeaveRequestTypeBalanceMutationShow',
                component: () => import('../views/leaveRequestTypeBalanceMutations/LeaveRequestTypeBalanceMutationShow.vue'),
                meta: {
                  backRoute: {
                    name: 'AdminLeaveRequestTypeBalanceMutations',
                  },
                },
                get redirect() {
                  return this.children[0];
                },
                children: [
                  {
                    path: '',
                    name: 'AdminLeaveRequestTypeBalanceMutationsDetails',
                    component: () => import('../views/leaveRequestTypeBalanceMutations/LeaveRequestTypeBalanceMutationDetails.vue'),
                    meta: {
                      backRoute: { name: 'AdminLeaveRequestTypeBalanceMutations' },
                    },
                  },
                ]
              }
            ],
          },
        ],
      },
    ]
  },
];
OCRoutes.forEach(route => router.addRoute('OC', route));